"use client";
import {
  createContext,
  type ReactNode,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

interface NavContextType {
  closeMenu: boolean;
  setCloseMenu: (value: boolean) => void;
  enableMenuTitle: boolean;
}

export interface NavProviderProps {
  enableMenuTitle: boolean;
  children: ReactNode;
}

const NavContext = createContext<NavContextType | null>(null);

export function NavProvider({ children, enableMenuTitle }: NavProviderProps) {
  const [closeMenu, setCloseMenu] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Automatically reset closeMenu after it's set to true
  useEffect(() => {
    if (closeMenu) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        setCloseMenu(false);
      }, 500);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [closeMenu]);

  return (
    <NavContext.Provider value={{ closeMenu, setCloseMenu, enableMenuTitle }}>
      {children}
    </NavContext.Provider>
  );
}

export function useNav() {
  const context = useContext(NavContext);
  if (!context) {
    throw new Error("useNav must be used within a NavProvider");
  }
  return context;
}
